import { Slab } from '../../render/parts'
import { Pedestal } from '../parts/worktop'
import type { AssetContext, AssetDefinition } from '../types'

/**
 * Standalone mobile pedestal: the shared `Pedestal` on castors, capped with a
 * thin top pad so it reads as a free-standing unit rather than a desk sub-part.
 * The carcass is inset in plan so the cap overhangs it and no faces align.
 */

const WIDTH = 0.42
const DEPTH = 0.58
const HEIGHT = 0.62
const CAP = 0.018

/** Carcass inset from the cap, in plan. */
const BODY_W = WIDTH - 0.01
const BODY_D = DEPTH - 0.008
/** Carcass runs 6mm into the cap so the two solids interpenetrate. */
const BODY_H = HEIGHT - CAP + 0.006

function PedestalMobile({ accent, variant = 'x3' }: AssetContext) {
  const accentDrawer = variant === 'accent'

  return (
    <group>
      <Pedestal
        width={BODY_W}
        depth={BODY_D}
        height={BODY_H}
        drawers={3}
        accent={accent}
        accentDrawer={accentDrawer}
        mobile
      />

      {/* Top pad — the usable surface. */}
      <Slab
        tone="shell"
        size={[WIDTH, DEPTH, CAP]}
        radius={0.008}
        position={[0, HEIGHT - CAP / 2, 0]}
      />
    </group>
  )
}

export const definition: AssetDefinition = {
  id: 'pedestal-mobile',
  name: 'Cajonera móvil',
  category: 'storage',
  footprint: [WIDTH, DEPTH],
  height: HEIGHT,
  surfaceHeight: HEIGHT,
  accentable: true,
  variants: [
    { id: 'x3', name: '3 cajones' },
    { id: 'accent', name: 'Cajón acento' },
  ],
  keywords: [
    'cajonera',
    'buc',
    'pedestal',
    'ruedas',
    'móvil',
    'mobile pedestal',
    'drawer unit',
    'storage',
  ],
  Component: PedestalMobile,
}
